(function () {
  const frameImages = {
    "Rolled Canvas": "https://cdn.shopify.com/s/files/1/0746/4982/9532/files/rolled_canvas.webp?v=1782184362",
    "Frameless": "https://cdn.shopify.com/s/files/1/0746/4982/9532/files/Frameless.webp?v=1783411562",
    "Stretch + Gold Frame": "https://cdn.shopify.com/s/files/1/0746/4982/9532/files/Gold_Frame.webp?v=1783411600",
    "Stretch + Silver Frame": "https://cdn.shopify.com/s/files/1/0746/4982/9532/files/Silver_Frame.webp?v=1783411632",
    "Stretch + Black Frame": "https://cdn.shopify.com/s/files/1/0746/4982/9532/files/black_frame.webp?v=1782184444",
    "Stretch + White Frame": "https://cdn.shopify.com/s/files/1/0746/4982/9532/files/white_frame.webp?v=1782184457",
    "Stretch + Wood Frame": "https://cdn.shopify.com/s/files/1/0746/4982/9532/files/wood_frame.webp?v=1782184470"
  };

  function normalize(text) {
    return (text || "").toLowerCase().replace(/\s+/g, " ").replace(/\s*\+\s*/g, " + ").replace(/\bsiiver\b/g, "silver").trim();
  }

  function getLabelText(select) {
    if (!select.id || !window.CSS || !CSS.escape) return "";

    const label = document.querySelector('label[for="' + CSS.escape(select.id) + '"]');
    return label ? label.textContent : "";
  }

  function isFrameSelect(select) {
    const name = normalize(select.getAttribute("name"));
    const label = normalize(getLabelText(select));
    const optionTexts = Array.from(select.options)
      .map(function (option) {
        return normalize(option.textContent);
      })
      .join(" | ");

    return (
      name.includes("rolled canvas") ||
      name.includes("finish") ||
      label.includes("rolled canvas") ||
      label.includes("finish") ||
      label.includes("frameless") ||
      label.includes("framed") ||
      (optionTexts.includes("rolled canvas") && optionTexts.includes("frameless"))
    );
  }

  function updateSelectedState(container, selectedValue) {
    const currentText = container.querySelector("[data-frame-current]");
    if (currentText) currentText.textContent = selectedValue;

    container.querySelectorAll(".spazioil-frame-swatch").forEach(function (button) {
      const isSelected = button.dataset.value === selectedValue;
      button.classList.toggle("is-selected", isSelected);
      button.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });
  }

  function getOptionWrapper(select) {
    return (
      select.closest(".product-form__input") ||
      select.closest(".selector-wrapper") ||
      select.closest(".variant-picker__option") ||
      select.closest(".variant-picker__field") ||
      select.closest(".form-field") ||
      select.closest(".select") ||
      select.parentElement
    );
  }

  function getCommonAncestor(elements) {
    if (!elements.length) return null;

    let ancestor = elements[0];

    while (ancestor) {
      if (elements.every(function (element) {
        return ancestor.contains(element);
      })) {
        return ancestor;
      }

      ancestor = ancestor.parentElement;
    }

    return null;
  }

  function hideOriginalFrameLabel(frameSelect, wrapper) {
    const possibleLabels = [];

    if (frameSelect.id && window.CSS && CSS.escape) {
      const labelForSelect = document.querySelector('label[for="' + CSS.escape(frameSelect.id) + '"]');
      if (labelForSelect) possibleLabels.push(labelForSelect);
    }

    if (wrapper) {
      wrapper.querySelectorAll("label, .form__label, .variant-picker__label").forEach(function (label) {
        possibleLabels.push(label);
      });

      if (wrapper.previousElementSibling) {
        possibleLabels.push(wrapper.previousElementSibling);
      }

      if (wrapper.parentElement) {
        wrapper.parentElement.querySelectorAll("label, .form__label, .variant-picker__label").forEach(function (label) {
          possibleLabels.push(label);
        });
      }
    }

    possibleLabels.forEach(function (label) {
      const text = normalize(label.textContent);

      if (
        text.includes("rolled canvas") ||
        text.includes("frameless") ||
        text.includes("framed") ||
        text.includes("finish")
      ) {
        label.classList.add("spazioil-hidden-frame-label");
      }
    });
  }

  function initFrameSwatches() {
    const selects = Array.from(document.querySelectorAll('select[name^="options["]'));
    const frameSelect = selects.find(isFrameSelect);

    if (!frameSelect || frameSelect.dataset.spazioilFrameReady === "true") return;

    const wrapper = getOptionWrapper(frameSelect);

    if (!wrapper) return;

    const productForm =
      frameSelect.closest('form[action*="/cart/add"]') ||
      frameSelect.closest("product-form") ||
      document;

    const optionSelects = Array.from(productForm.querySelectorAll('select[name^="options["]'));
    const optionWrappers = optionSelects
      .map(getOptionWrapper)
      .filter(Boolean);

    let variantRoot =
      frameSelect.closest("variant-selects") ||
      frameSelect.closest("variant-radios") ||
      frameSelect.closest(".variant-picker") ||
      getCommonAncestor(optionWrappers) ||
      wrapper.parentElement;

    if (!variantRoot || variantRoot.tagName === "FORM") {
      variantRoot = wrapper.parentElement || wrapper;
    }

    variantRoot.classList.add("spazioil-frame-variant-root");

    const container = document.createElement("div");
    container.className = "spazioil-frame-swatches";

    const title = document.createElement("div");
    title.className = "spazioil-frame-title";
    title.innerHTML =
      'Frame Option: <span class="spazioil-frame-current" data-frame-current>' +
      frameSelect.value +
      "</span>";

    const grid = document.createElement("div");
    grid.className = "spazioil-frame-grid";

    Array.from(frameSelect.options).forEach(function (option) {
      const value = option.value;
      const imageKey = Object.keys(frameImages).find(function (key) { return normalize(key) === normalize(value); });
      const imageUrl = frameImages[imageKey];

      const button = document.createElement("button");
      button.type = "button";
      button.className = "spazioil-frame-swatch";
      button.dataset.value = value;
      button.setAttribute("aria-label", value);
      button.setAttribute("aria-pressed", value === frameSelect.value ? "true" : "false");
      button.title = value;

      if (value === frameSelect.value) {
        button.classList.add("is-selected");
      }

      if (imageUrl) {
        const img = document.createElement("img");
        img.src = imageUrl;
        img.alt = value;
        img.loading = "lazy";
        button.appendChild(img);
      } else {
        const fallbackText = document.createElement("span");
        fallbackText.textContent = value;
        button.appendChild(fallbackText);
      }

      button.addEventListener("click", function () {
        frameSelect.value = value;

        frameSelect.dispatchEvent(new Event("input", { bubbles: true }));
        frameSelect.dispatchEvent(new Event("change", { bubbles: true }));

        updateSelectedState(container, value);
      });

      grid.appendChild(button);
    });

    container.appendChild(title);
    container.appendChild(grid);

    hideOriginalFrameLabel(frameSelect, wrapper);

    wrapper.classList.add("spazioil-hidden-frame-select");

    variantRoot.insertAdjacentElement("afterend", container);

    frameSelect.addEventListener("change", function () {
      updateSelectedState(container, frameSelect.value);
    });

    frameSelect.dataset.spazioilFrameReady = "true";
  }

  document.addEventListener("DOMContentLoaded", initFrameSwatches);

  document.addEventListener("shopify:section:load", function () {
    setTimeout(initFrameSwatches, 50);
  });

  setTimeout(initFrameSwatches, 500);
})();